import {baseFetch, injectCacheTags} from './base';
import {resolveAPIRoute} from '@/lib/routes';
import type {Profile, StatusUpdate} from '@/types/api/profile';
import type {AuthenticationMethod} from '@/types/api/authentication';

export enum ProfileRoutes {
  Profile = 'base.profile',
  OTP = 'base.profile.otp',
  OTPVerify = 'base.profile.otp.verify',
  IdentityVerify = 'base.profile.identity-verify',
  IDCard = 'base.profile.idCard',
  Selfie = 'base.profile.selfi'
}

export async function getProfile(requestArgs?: RequestInit) {
  return (
    await baseFetch(
      resolveAPIRoute(ProfileRoutes.Profile),
      injectCacheTags([ProfileRoutes.Profile], requestArgs)
    )
  ).data as Profile;
}

export async function requestOTP(
  requestArgs?: Omit<RequestInit, 'body'> & {
    body: AuthenticationMethod;
  }
) {
  return (
    await baseFetch(
      resolveAPIRoute(ProfileRoutes.OTP),
      injectCacheTags([ProfileRoutes.Profile, ProfileRoutes.OTP], {
        method: 'POST',
        ...requestArgs,
        body: requestArgs?.body as BodyInit
      })
    )
  ).data as EmptyObject;
}

export async function requestOTPVerify(
  requestArgs?: Omit<RequestInit, 'body'> & {
    body: {code: string} & AuthenticationMethod;
  }
) {
  return (
    await baseFetch(
      resolveAPIRoute(ProfileRoutes.OTPVerify),
      injectCacheTags([ProfileRoutes.Profile, ProfileRoutes.OTPVerify], {
        method: 'POST',
        ...requestArgs,
        body: requestArgs?.body as unknown as BodyInit
      })
    )
  ).data as AuthenticationMethod;
}

export async function requestIdentityVerification(
  requestArgs?: Omit<RequestInit, 'body'> & {
    body: {
      idNo: string;
      birthDate: string;
    };
  }
) {
  return (
    await baseFetch(
      resolveAPIRoute(ProfileRoutes.IdentityVerify),
      injectCacheTags([ProfileRoutes.Profile, ProfileRoutes.IdentityVerify], {
        method: 'POST',
        ...requestArgs,
        body: requestArgs?.body as unknown as BodyInit
      })
    )
  ).data as null;
}

export async function setIdCard(
  requestArgs?: Omit<RequestInit, 'body'> & {body: FormData}
) {
  return (
    await baseFetch(
      resolveAPIRoute(ProfileRoutes.IDCard),
      injectCacheTags([ProfileRoutes.Profile, ProfileRoutes.IDCard], {
        method: 'PUT',
        ...requestArgs,
        body: requestArgs?.body
      }),
      undefined,
      undefined,
      6e4
    )
  ).data as StatusUpdate;
}

export async function setSelfie(
  requestArgs?: Omit<RequestInit, 'body'> & {body: FormData}
) {
  return (
    await baseFetch(
      resolveAPIRoute(ProfileRoutes.Selfie),
      injectCacheTags([ProfileRoutes.Profile, ProfileRoutes.Selfie], {
        method: 'PUT',
        ...requestArgs,
        body: requestArgs?.body
      }),
      undefined,
      undefined,
      9e4
    )
  ).data as StatusUpdate;
}
